import { render, staticRenderFns } from "./ActionReview.vue?vue&type=template&id=e85434d6"
import script from "./ActionReview.vue?vue&type=script&lang=js"
export * from "./ActionReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports